import React from 'react';
import PropTypes from 'prop-types';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

const SupportingDocsActions = ({ permissions, deleteSupportingDocument, viewSupportingDocument, canDelete }) => ({
  id: 'action-column',
  Header: <span>Actions</span>,
  /* eslint-disable react/prop-types, react/no-unstable-nested-components */
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { AccessControl.hasPermission(permissions, [ActivityPerms.scannedDownload]) && <button
        className="btn btn-sm btn-danger"
        type="button"
        title="View document"
        onClick={ () => viewSupportingDocument(row.original) }
      >
        <span className="icon icon-share" />
      </button> }
      { AccessControl.hasPermission(permissions, [ActivityPerms.scannedSupDocs]) && canDelete && <button
        className="btn btn-sm btn-danger"
        type="button"
        title="Delete form"
        onClick={ () => deleteSupportingDocument(row.original) }
      >
        <span className="icon icon-delete" />
      </button> }
    </div>
  /* eslint-enable react/prop-types, react/no-unstable-nested-components */
  ),
  className: 'col-10p'
});

SupportingDocsActions.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  viewSupportingDocument: PropTypes.func.isRequired,
  deleteSupportingDocument: PropTypes.func.isRequired,
  canDelete: PropTypes.bool,
};

SupportingDocsActions.defaultProps = {
  permissions: [],
  canDelete: false
};

export default SupportingDocsActions;
